// extracted by mini-css-extract-plugin
module.exports = {"container":"domain-instruction_container__2Hj8y","title":"domain-instruction_title__3B31x","description":"domain-instruction_description__30_Xd"};